export enum PaymentMethodEnum {
  // CARD = "CARD", Not available yet
  VIREMENT = "VIREMENT",
  PRELEVEMENT = "PRELEVEMENT",
}
